import React from 'react';
import Button from '../common/Button';

const ProfileImageTab = ({
    basicInfo,
    selectedImage,
    imagePreview,
    loading,
    onImageSelect,
    onUploadProfileImage
}) => {
    return (
        <div>
            <div className="mb-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Profile Image</h3>
                
                {/* Current Profile Image */}
                <div className="mb-6">
                    <h4 className="text-md font-medium text-gray-700 mb-3">Current Profile Image</h4>
                    {basicInfo.profileImageUrl ? (
                        <div className="flex justify-center">
                            <img
                                src={basicInfo.profileImageUrl}
                                alt="Current Profile"
                                className="max-h-[300px] max-w-[300px] rounded-lg shadow-md object-cover"
                                onError={(e) => {
                                    e.target.src = '/placeholder-doctor.jpg';
                                    e.target.alt = 'No image available';
                                }}
                            />
                        </div>
                    ) : (
                        <div className="flex justify-center items-center h-[300px] w-[300px] bg-gray-100 rounded-lg border-2 border-dashed border-gray-300">
                            <p className="text-gray-500">No profile image set</p>
                        </div>
                    )}
                </div>

                {/* Upload New Image */}
                <div className="space-y-4">
                    <h4 className="text-md font-medium text-gray-700">Upload New Image</h4>
                    
                    {/* File Input */}
                    <div>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={onImageSelect}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <p className="text-sm text-gray-500 mt-1">Select an image file (JPG, PNG, etc.)</p>
                    </div>

                    {/* Image Preview */}
                    {imagePreview && (
                        <div>
                            <h5 className="text-sm font-medium text-gray-700 mb-2">Preview</h5>
                            <div className="flex justify-center">
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    className="max-h-[200px] max-w-[200px] rounded-lg shadow-md object-cover"
                                />
                            </div>
                        </div>
                    )}

                    {/* Upload Button */}
                    <div className="flex justify-end">
                        <Button
                            type="button"
                            variant="primary"
                            onClick={onUploadProfileImage}
                            disabled={loading || !selectedImage}
                        >
                            {loading ? 'Uploading...' : 'Upload New Image'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileImageTab; 